import React from 'react';
import PropTypes from 'prop-types';
import { Col, Label } from 'reactstrap';
import Select from 'react-select';
import { IconeCarregar } from '../../../components/Icones';
import { setTemaSeletor } from '../../../../../utils/formatar';

function InputSelect({ xs, sm, md, lg, xl, className, title, noTitle, placeholder, name, inputValue, onInputChange, value, onChange, onBlur, error, loading, options, disabled, required, isClearable = true, defaultMenuIsOpen, isSearchable = true  }) {

    const handleChange = event => onChange && onChange(event);

    const handleBlur = event => onBlur && onBlur(event);

    const filtro = (option, searchText) => (option.label && option.label.toUpperCase().includes(searchText.toUpperCase()) ||
                                            option.value && option.value.toString().toUpperCase().includes(searchText.toUpperCase()));

    return (
        <Col 
            xs={xs || 'auto'}
            sm={sm || 'auto'}
            md={md || 'auto'}
            lg={lg || 'auto'}
            xl={xl || 'auto'}
            className={`${(className && className.includes('mb')) ? '' : error ? 'mb-1' : 'mb-4'} w-100 ${className ? className : ''}`}
        >
            <div className="w-100">
                {title ? (
                    <Label>
                        {title}{required ? <span className="label-danger">{' *'}</span> : ""}
                        {loading && <IconeCarregar className="label-carregar" tamanho="lg" />} 
                    </Label>
                ) : noTitle ? "" : <Label className="hide-item">empty</Label>}
                <Select
                    name={name}
                    className="select" 
                    menuPlacement="auto" 
                    placeholder={placeholder || "Selecione"}
                    noOptionsMessage={() => loading ? "Carregando" : "Sem opções"}
                    isSearchable={isSearchable && (options.length > 5 || options.length === 0)}
                    inputValue={inputValue}
                    onInputChange={onInputChange}
                    defaultMenuIsOpen={defaultMenuIsOpen}
                    value={value}
                    theme={theme => setTemaSeletor(theme)}
                    onChange={handleChange}
                    options={options}
                    isClearable={isClearable}
                    filterOption={filtro} 
                    onBlur={handleBlur}
                    isDisabled={disabled}
                />
                {error ? <Label className="label-danger">{error}</Label> : <Label className="hide-item">empty</Label>}
            </div>
        </Col>
    )
}

InputSelect.propTypes = {
    xs: PropTypes.number,
    sm: PropTypes.number,
    md: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
    className: PropTypes.string,
    title: PropTypes.string,
    noTitle: PropTypes.bool,
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    inputValue: PropTypes.string,
    onInputChange: PropTypes.func,
    defaultMenuIsOpen: PropTypes.bool,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    error: PropTypes.string,
    loading: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.exact({
        value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, PropTypes.object ]),
        label: PropTypes.string,
      })
    ).isRequired,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    isSearchable: PropTypes.bool,
}

export default InputSelect


// WEBPACK FOOTER //
// ./src/modules/comum/tables/components/inputs/InputSelect.js